import { httpsCallable } from "firebase/functions";
import { functions } from "../../../config/firebase-config";
import { notifyPermissionDenied } from "../handleCallableError";

export const createDealership = async (newDealershipData) => {
  try {
    const createDealershipFn = httpsCallable(functions, "createDealershipV2");
    const safeDealershipData = { ...(newDealershipData || {}) };
    delete safeDealershipData.confirmPassword;
    safeDealershipData.requestedApp = "group_web";
    const result = await createDealershipFn(safeDealershipData);
    const response = result.data;
    const message = response?.otherRole
      ? `Concesionaria creada. La persona ya existía como ${response.otherRole.role} (${response.otherRole.email}). Se creó una cuenta separada de administrador.`
      : response?.message || "Concesionaria creada con éxito";
    return { ...response, message };
  } catch (error) {
    console.error("Error creando concesionario:", error);
    notifyPermissionDenied(error);
    return {
      success: "no",
      message: "Error al crear el concesionario",
      error: error.message,
    };
  }
};
